{
  "longPressMessage": "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
}
